<template>
  <div class="main-container">
    <div class="bread" v-if="!!$route.query.recommend">
      <router-link :to="{ name: 'Index' }">
        {{ $t("common.indexPage") }}
      </router-link>
      <span class="slash">/</span>
      <router-link
        :to="{
          name: 'IndexRecommendGoods',
          query: {
            title: $route.query.title,
            recommend: $route.query.recommend,
          },
        }"
      >
        {{ $route.query.title }}
      </router-link>
      <span class="slash">/</span>
      <span class="current">{{ goods.goods }}</span>
    </div>
    <div class="bread" v-else>
      <router-link :to="{ name: 'Goods' }">{{ $t("goods.goods") }}</router-link>
      <span class="slash">/</span>
      <span class="current">{{ goods.goods }}</span>
    </div>
    <template v-if="goods.status == 1">
      <div class="detail">
        <div style="padding:0 80px;" >
          <img style="max-width: 300px;" class="cover" :src="goods.cover_img" />
        </div>
        
        <div class="right">
          <div class="title">{{ goods.goods }}</div>
          <div class="instruction" :title="goods.instruction">
            {{ goods.instruction }}
          </div>
          <div class="author-wrap">
            <span class="buy-num">
              {{ goods.sales_num + goods.sales_base }}{{ $t("goods.totalBuy") }}
            </span>
          </div>
          <div class="price-wrap">
            <span class="price">
              <!-- <Currency v-if="goods.price"></Currency> -->
              <CurrencyNew
                v-if="goods.price"
                :price="goods.price"
                :priceUnderline="goods.underlined_price"
                :priceTwo="true"
                :isUnderlineLeft="false"
              ></CurrencyNew>
              <!-- <span v-if="goods.price">{{ goods.price | price }}</span> -->
              <span v-else>{{ $t("common.free") }}</span>
            </span>
            <span class="ship-price">
              <span>{{ $t("goods.freight") }}</span>
              <Currency v-if="goods.ship_price"></Currency>
              <span v-if="goods.ship_price">
                {{ goods.ship_price | price }}
              </span>
              <span v-else>{{ $t("goods.carriage") }}</span>
            </span>
          </div>
          <Coupon
            v-if="couponList.length > 0"
            class="coupon"
            @getCoupon="getCoupon"
            :couponList="couponList"
            :defaultCount="3"
          ></Coupon>
          <div v-else class="coupon-empty"></div>
          <div class="buy-num-wrap">
            <img
              src="../../images/goods/jian@2x.png"
              style="width: 34px"
              @click="changeNum(-1)"
            />
            <span class="num">{{ num }}</span>
            <img
              src="../../images/goods/jia@2x.png"
              style="width: 34px"
              @click="changeNum(1)"
            />
            <span class="stock">
              <span>{{ $t("goods.stock") }}</span>
              <span v-if="goods.stock - goods.sales_num < 0">0</span>
              <span v-else>{{ goods.stock - goods.sales_num }}</span>
            </span>
          </div>
          <div class="spell" v-if="goods.spell_price > 0">
            <div class="btn-buy btn-buy-spell">
              <div class="price">
                <Currency></Currency>
                <span v-if="goods.head_price">
                  {{ goods.head_price / 100 }}
                </span>
                <span v-else>{{ goods.spell_price / 100 }}</span>
              </div>
              <div class="label">{{ $t("goods.beginGroup") }}</div>
              <div class="spell-qr">
                <div class="header">{{ $t("goods.scanGroup") }}</div>
                <vue-qr :text="shareUrl" :size="200" class="qrcode"></vue-qr>
              </div>
            </div>
            <div class="btn-buy" @click="goToBuy">
              <div class="price">
                <Currency></Currency>
                <span>{{ goods.price / 100 }}</span>
              </div>
              <div class="label">{{ $t("goods.buyDirect") }}</div>
            </div>
            <div style="clear: both"></div>
          </div>
          <div v-else class="btn-buy" @click="goToBuy">
            {{ $t("goods.buyNow") }}
          </div>
          <div class="operate">
            <a href="javascript:void(0)" class="share" @click="shareBook"></a>
          </div>
        </div>
      </div>
      <div class="main">
        <el-tabs class="left el-tabs-custom" v-model="activeName">
          <el-tab-pane :label="$t('goods.detail')" name="detail">
            <Rich class="goods-detail" v-html="goods.details"></Rich>
          </el-tab-pane>
          <el-tab-pane :label="$t('goods.comment')+ `（${goods.comment_count}）`" name="comment">
            <div
              class="comment-item"
              v-for="comment in comments"
              :key="comment.id"
            >
              <div class="header">
                <img class="avatar" :src="comment.avatar" />
                <span class="nickname">{{ comment.nickname }}</span>
                <div style="position: relative">
                  <el-rate v-model="comment.grade"></el-rate>
                  <div
                    style="
                      position: absolute;
                      left: 0;
                      top: 0;
                      right: 0;
                      bottom: 0;
                      z-index: 1;
                    "
                  ></div>
                </div>
                <div style="flex-grow: 1"></div>
                <a
                  class="operate delete"
                  v-if="$store.state.user_info.id == comment.uid"
                  @click="onCommentDelete(comment)"
                >
                  {{ $t("common.delete") }}
                </a>
                <a
                  class="operate complaint"
                  v-else
                  @click="onComplaint(comment)"
                >
                  {{ $t("common.complaint") }}
                </a>
              </div>
              <div class="content">{{ comment.content }}</div>
              <div class="time">{{ comment.created_at | tsFormatLong }}</div>
            </div>
            <el-pagination
              class="pager"
              background
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-size="limit"
              layout="prev, pager, next, total, jumper"
              :total="total"
              v-if="total > 0"
            ></el-pagination>
            <Empty
              v-if="comments.length == 0"
              :title="$t('goods.detailEmpty')"
            />
          </el-tab-pane>
        </el-tabs>
        <div class="right">
          <div class="header">
            <img src="../../images/goods/book@3x.png" />
            <span>{{ $t("goods.recommend") }}</span>
          </div>
          <div class="recommend" v-for="item in recommends" :key="item.id">
            <div class="center cover-wrap">
              <router-link
                :to="{ name: 'GoodsDetail', params: { id: item.id } }"
              >
                <img class="cover" :src="item.cover_img_z" />
              </router-link>
              <router-link
                :to="{ name: 'GoodsDetail', params: { id: item.id } }"
              >
                <div class="price-wrap">
                  <div class="price">
                    <Currency v-if="item.price"></Currency>
                    <span v-if="item.price">{{ item.price | price }}</span>
                    <span v-else>{{ $t("common.free") }}</span>
                  </div>
                </div>
              </router-link>
            </div>
            <router-link :to="{ name: 'GoodsDetail', params: { id: item.id } }">
              <div class="title">{{ item.name }}</div>
            </router-link>
            <div class="instruction">{{ item.instruction }}</div>
          </div>
        </div>
      </div>
      <el-dialog
        :title="$t('common.share')"
        :visible.sync="showShareModal"
        width="400px"
      >
        <vue-qr :text="shareUrl" :size="200" class="center"></vue-qr>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="showShareModal = false">
            {{ $t("common.confirm") }}
          </el-button>
        </span>
      </el-dialog>
      <Complaint ref="complaint"></Complaint>
    </template>
    <CourseSoldOut
      v-if="goods.status == 2 || goods.status == 3"
      router-name="Book"
      :name="$t('goods.goods')"
    ></CourseSoldOut>
  </div>
</template>
<script>
import VueQr from "vue-qr";
import Complaint from "@/components/community/components/Complaint.vue";
import Coupon from "../../components/Coupon.vue";
import CourseSoldOut from "../../components/CourseSoldOut.vue";
export default {
  name: "GoodsDetail",
  components: {
    VueQr,
    Complaint,
    Coupon,
    CourseSoldOut,
  },
  data() {
    return {
      id: this.$route.params.id,
      goods: {},
      couponList: [],
      num: 1,
      showShareModal: false,
      activeName: "detail",
      comments: [],
      recommends: [],
      page: 1,
      limit: 10,
      total: 0,
    };
  },
  computed: {
    shareUrl() {
      return (
        this.$store.state.commonSetting.h5_address +
        "/goods_detail?id=" +
        this.id
      );
    },
  },
  async created() {
    await this.getData();
    await this.incrementBrosweNum();

  },
  methods: {
    async incrementBrosweNum() {
      await this.$http.put("/api/app/goods/pv/" + this.id);
      this.goods.browse_num++;
    },
    async getData() {
      let data = await this.$http.get("/api/app/goods/detail/" + this.id);
      this.goods = data;
      this.couponList = data.couponList;
      this.recommends = await this.$http.get(
        "/api/app/goods/recommend/" + this.id,
      );
    },
    async collect() {
      this.goods.is_collected = await this.$http.post(
        "/api/app/collect",
        {
          goods_id: this.id,
          type: 4,
        },
        true,
      );
      this.goods.is_collected = true;
      await this.$success(this.$t("common.collectSuccess"));
    },
    async cancelCollect() {
      await this.$http.put(
        "/api/app/collect/cancel/" + this.goods.is_collected + "/4",
      );
      this.goods.is_collected = false;
      await this.$success(this.$t("common.collectCancel"));
    },
    shareBook() {
      this.showShareModal = true;
    },
    changeNum(step) {
      let newNum = this.num + step;
      if (newNum < 1 || newNum > this.goods.stock - this.goods.sales_num) {
        return;
      }
      this.num = newNum;
    },
    goToBuy() {
      if (this.num > this.goods.stock - this.goods.sales_num) {
        this.$info(this.$t("common.stockEmpty"));
        return;
      }
      let obj = {
        shop_id: this.goods.id,
        shop_type: 10,
        coupon_id: 0,
        product_number: this.num,
      };
      this.$router.push({
        name: "OrderConfirm",
        params: { id: this.id },
        query: {
          type: 12,
          num: this.num,
          order_type: 1,
          shop_infos: JSON.stringify([obj]),
        },
      });
    },
    async getCoupon(id) {
      let data = await this.$http.get("/api/app/userGetCoupon/" + id);
      this.couponList.filter(c => c.id == id)[0].is_can_get =
        data.is_continue_get == 1 ? 1 : 0;
      this.$message({
        message: this.$t("common.couponSuccess"),
        type: "success",
      });
    },
    async getComment() {
      let data = await this.$http.get("/api/app/goods/comments/" + this.id, {
        page: this.page,
        limit: this.limit,
      });
      this.comments = data.data;
      this.total = data.total;
    },
    async handleCurrentChange(page) {
      this.page = page;
      await this.getComment();
    },
    async onCommentDelete(item) {
      await this.$promiseConfirm(this.$t("common.deleteConfirm"), {
        type: "warning",
      });
      await this.$http.delete("/api/app/goods/comment/" + item.id);
      await this.getComment();
    },
    onComplaint(item) {
      this.$refs.complaint.show(3, item.id);
    },
  },
  watch: {
    async activeName() {
      if (this.activeName == "comment") {
        await this.getComment();
      }
    },
    async $route() {
      this.id = this.$route.params.id ||this.$route.query.id;

      if(!this.id) return
      await this.getData();
      await this.incrementBrosweNum();
      await this.getComment()
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../css/goods-detail.scss";
</style>
<style lang="scss">
.spell-qr {
  img {
    max-width: 100%;
    border-radius: 0 0 7px 7px;
    vertical-align: bottom;
  }
}
</style>
